import * as types from '../types';
import * as _ from 'lodash';
import { deentitize } from './stringDeentitize';
import { Injectable } from '@angular/core';
import { LoggingService } from '../services/logging.service';
import * as commonTypes from '../types';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FORM_ERROR_SHOW } from '../../../setup/configurations';
import { WindowRefService } from '../services/window-ref.service';
import { FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms';

@Injectable()
export class FormlyManipulation {

    private unsupportedTypes = [];
    private noValidationRequiredTypes = ['statictext'];
    private nativeWindow: any;
    constructor( private loggy: LoggingService, windowRef: WindowRefService) {
        this.nativeWindow = windowRef.getNativeWindow();
    }

    /*
        private functions
    */
    private generateQuestionGroupTemplate(response: any, formlyModel: Object): types.IQuestionGroupTemplate[] {
        const questionGroupTemplates: types.IQuestionGroupTemplate[] = [];
        // filter out blank field group
        const requiredFields: string[] = response.formschema['required'];
        const fieldDefinitions = _.omitBy(response.formschema['properties'],
            (value, key) => _.isNil(value) ||
                            _.indexOf(this.unsupportedTypes, value.option.type) > -1 ||
                            _.indexOf(this.unsupportedTypes, value.widget) > -1 );

        _.filter(response.formschema.fieldsets, (fieldset) => fieldset.fields.length)
        .map((fieldset, index: number) => {
            const model = {};
            const questionTemplates: types.IQuestionTemplate[] =
                this.generateQuestionTemplateFieldGroup(fieldset, index, requiredFields, fieldDefinitions, response.formdata, model);

            const questionGroupTemplate: types.IQuestionGroupTemplate = {
                className: String(fieldset['class']),
                fieldGroup: questionTemplates // get from this.generateQuestionTemplateFieldArray()
            };

            _.mergeWith(formlyModel, model, (objValue, srcValue) => {
                if (_.isArray(objValue)) {
                    return objValue.concat(srcValue);
                }
            });

            questionGroupTemplates.push(questionGroupTemplate);

        });
        //console.log(questionGroupTemplates);
        return questionGroupTemplates;
    }

    private generateQuestionTemplateFieldGroup(
        fieldset, index: number, requiredFields: string[], fieldDefinitions, formData: Object, model: Object): types.IQuestionTemplate[] {
        const questionTemplates: types.IQuestionTemplate[] = [];

        fieldset['fields'].map( (fieldName: string) => {
            const field = fieldDefinitions[fieldName];
            let fileEmbeddedInfo;

            const validations: string[] = [];
            if (formData && _.size(formData)) {
                if (_.has(formData, fieldName)) {
                    if (field && !_.has(field, 'oneOf') && (field.widget !== 'multiselect') && (field.widget !== 'multicheckbox') ) {
                        model[fieldName] = formData[fieldName];
                    } else {
                        const defValue = formData[fieldName];
                        let valueExist = undefined;
                        if (_.has(field, 'oneOf')) {
                            valueExist = _.find(field['oneOf'], (item) => {
                                if (_.isArray(defValue)) {
                                    return _.indexOf(defValue, item.enum[0]) > -1;
                                }
                                return item.enum[0] === defValue;
                            });
                        } else if ((field.widget === 'multiselect') || (field.widget === 'multicheckbox') ) {
                            valueExist = _.filter(field.items[0]['anyOf'], (item) => {
                                if (_.isArray(defValue)) {
                                    return _.indexOf(defValue, item.enum[0]) > -1;
                                }
                                return item.enum[0] === defValue;
                            });
                        }

                        if (valueExist) {
                            model[fieldName] = formData[fieldName];
                        }
                    }
                }
            }
            if (field) { // only keep processing if field is defined
                if (field.widget === 'file' || field.widget === 'files') {
                    if (formData && _.size(formData)) {
                        if (_.has(formData, fieldName)) {
                            fileEmbeddedInfo = [];
                            (_.isArray(formData[fieldName]) ? formData[fieldName] : [formData[fieldName]]).map( (fileId: string) => {
                                if (_.has(formData, '_embedded') && _.has(formData['_embedded'], fileId)) {
                                    fileEmbeddedInfo.push( formData['_embedded'][fileId]);
                                    // model['oldFiles'] = {};
                                    // model['oldFiles'][fieldName] = formData[fieldName];
                                }
                            });
                        }
                    }
                }

                questionTemplates.push(this.generateQuestionTemplate(index, field, fieldName, requiredFields, fileEmbeddedInfo));
            }
        });

        return questionTemplates;
    }


    private generateQuestionTemplate(
        groupIndex: number,
        field,
        fieldName: string,
        requiredFields: string[],
        fileEmbeddedInfo?
    ): types.IQuestionTemplate {
        const questionCls = _.has(field.option, 'class') ? field.option.class : `${fieldName}-class`;
        const validations: string[] = [];


        if (_.indexOf(requiredFields, fieldName) > -1) {
            validations.push('required');
        }

        if (_.has(field.option, 'type') && field.option['type'] !== '') {
            validations.push(field.option['type']);
        }

      const questionTemplate: types.IQuestionTemplate = {
        className: `${questionCls}`,
        type: field.widget,
        key: fieldName,
        name: fieldName,
        templateOptions: {},
        validators: {},
        expressionProperties: {},
            // formatters: [(val) => {
            //     debugger;
            // }],
            // parsers: [(value) => {
            //     debugger;
            //     // if (_.isPlainObject(value)) {
            //     //     return `${value.year}-0${value.month}-0${value.day}`;
            //     // }
            // }]
        };

        if (!_.has(field, 'description')) {
            questionTemplate.wrapper = ['fieldset'];
        }

        if (_.has(field, 'default')) {
            questionTemplate.defaultValue = field['default'];
        }

        if (_.has(field.option, 'dependsOn')) {
            const parentValue = field.option.dependsOn.parents[0];
            if (_.has(parentValue, 'action')) {
                switch (parentValue['action']) {
                    case 'show':
                        questionTemplate.hideExpression = `model["` + _.keys(parentValue)[0] + `"] != ` + _.values(parentValue)[0];
                        if ( _.indexOf(this.noValidationRequiredTypes, field.widget) === -1) {
                            validations.push('required');
                        }
                    break;
                    case 'hide':
                        questionTemplate.hideExpression =  '1 == 1';
                    break;
                    case 'optional':
                        questionTemplate.hideExpression = `model["` + _.keys(parentValue)[0] + `"] != ` + _.values(parentValue)[0];
                        if (_.indexOf(validations, 'required') > -1) {
                            _.pull(validations, 'required');
                        }
                    break;
            }
        }
        // questionTemplate.expressionProperties = {};

        // questionTemplate.expressionProperties[`model["` + fieldName + `"]`] =
        // `model["` + _.keys(parentValue)[0] + `"] != ` + _.values(parentValue)[0];
        }

        // check correct/wrong answers against multi checkbox and radio widget
        if (field.widget === 'multicheckbox') // || field.widget === 'radio')
        {
           // questionTemplate.expressionProperties = {
           //     'templateOptions.disabled' : true,
           // };
           // defined in formlyConfigs.ts

           //validations.push('wronganswers');

          //console.log(questionTemplate.validators.validation);
        }


      if (validations.length) {

        questionTemplate.validators.validation = _.sortedUniq(validations);

            // applicable for file/files type only
            if (field.widget === 'file' || field.widget === 'files') {
                questionTemplate.validation = {
                    show: true
                };
            } else {

                questionTemplate.validation = {
                    show: FORM_ERROR_SHOW
                };
            }
        }
        questionTemplate.templateOptions = this.processQuestionTemplateOptions(field, (_.indexOf(validations, 'required') > -1));
        if (fileEmbeddedInfo) {
            _.mergeWith(questionTemplate.templateOptions, {
                fileInfo: fileEmbeddedInfo
            });
        }

        return questionTemplate;
    }

    private processQuestionTemplateOptions(field, isRequired: boolean): Object {
        const templateOptions = {};
        if (_.has(field, 'oneOf') || (field.widget === 'multiselect') || (field.widget === 'multicheckbox')) {
            if (_.has(field, 'oneOf')) {

                templateOptions['options'] = this._getSubItems(field.oneOf, field.widget);
            } else if (field.widget === 'multiselect') {
                templateOptions['options'] = this._getSubItems(field.items[0].anyOf, field.widget);
            }else if (field.widget === 'multicheckbox') {
              templateOptions['options'] = this._getSubItems(field.items[0].anyOf, field.widget);
            }
            // workaround for IE issue when no default selected value, the first item will be picked without trigger onChange event
            templateOptions['placeholder'] = '- Please select an option -';
            templateOptions['isOnMobile'] = this.nativeWindow.Modernizr.appleios;

        } else if (_.has(field.option, 'placeholder')) {
            templateOptions['placeholder'] = deentitize(field.option['placeholder']);
        }

        if (_.has(field.option, 'label')) {
            templateOptions['originalLabel'] = deentitize(field.option['label']);
            templateOptions['label'] =
                '<span>' +
                    deentitize(field.option['label']) +
                '</span>' +
                (isRequired ? ' <span class="mandatory">Essential</span>' : '');
        }

        if (_.has(field.option, 'helptext') && field.option.helptext !== '') {
            templateOptions['description'] = deentitize(field.option['helptext']);
        }

        // input subType
        if (_.has(field.option, 'type')) {
            templateOptions['type'] = field.option['type'];
        }

        // input adds-on
        if (_.has(field.option, 'addOnLeft')) {
            templateOptions['addOnLeft'] = field.option['addOnLeft'];
        }

        if (_.has(field.option, 'addonRight')) {
            templateOptions['addOnRight'] = field.option['addOnRight'];
        }

        if (_.has(field.option, 'href')) {
            templateOptions['href'] = field.option['href'];
        }

        if (_.has(field.option, 'fid')) {
            templateOptions['fid'] = field.option['fid'];
        }

        // if (_.has(field.option, 'label')) {
        //    templateOptions['label'] = field.option['label'];
        // }

        // textarea
        if (_.has(field.option, 'rows')) {
            templateOptions['rows'] = field.option['rows'];
        } else {
            templateOptions['rows'] = 2;
        }

        if (_.has(field.option, 'cols')) {
            templateOptions['cols'] = field.option['cols'];
        } else {
            templateOptions['cols'] = 1;
        }

        // input with pattern
        if (_.has(field, 'pattern') && field.pattern !== '' && this._isValidRegex(field.pattern)) {
            if (field.widget !== 'datepicker') {
                templateOptions['pattern'] = field.pattern;
            } else {
                templateOptions['date_pattern'] = field.pattern;
            }
        }

        if (_.has(field.option, 'displayFormat')) {
            templateOptions['displayFormat'] = field.option['displayFormat'];
        }

        // induction quiz question widget: multiseelct, multicheckbox, radio, select

        // question response DisplayAs: select-multiple,select-multiple-optional
        if (field.widget === 'multiselect') {
            templateOptions['multiple'] = true;
            //templateOptions['disabled'] = true;

          // pass correct answers value to the widget for checking later at component level
          if (_.has(field.option, 'correctanswers')) {
            templateOptions['correctanswers'] = field.option['correctanswers'];// set default correct answers (response option id) here from portal api for multicheckbox only
          }

          templateOptions['displayCorrect'] = false;// as default hide custom style for this widget
          templateOptions['displayWrong'] = false;// as default hide custom style for this widget

        }

        // widget: select, question response DisplayAs: select-one, select-one-optional

        // question response DisplayAs: checkboxes, checkboxes-optional
        if (field.widget === 'multicheckbox')
        {
            templateOptions['displayCorrect'] = false;// as default hide custom style for this widget
            templateOptions['displayWrong'] = false;// as default hide custom style for this widget

            templateOptions['multiple'] = true;


            // timedelay is only for multi-checkbox
            templateOptions['disabled'] = true;// set multicheckbox to be default disabled for timedelay
            if (_.has(field.option, 'timedelay')) {
              templateOptions['timedelay'] = field.option['timedelay'];// set timedelay value here from portal api for multicheckbox only
            }

            // pass correct answers value to the widget for checking later at component level
            if (_.has(field.option, 'correctanswers')) {
              templateOptions['correctanswers'] = field.option['correctanswers'];// set default correct answers (response option id) here from portal api for multicheckbox only
            }

        }

        // question response DisplayAs: single-select-radio, single-select-radio-optional also including generate radio button
        // custom formly-field-radio defined in node_modules\@ngx-formly\bootstrap\@ngx-formly\bootstrap.es5.js
        if (field.widget === 'radio') {

          // pass correct answers value to the widget for checking later at component level
          if (_.has(field.option, 'correctanswers')) {
            templateOptions['correctanswers'] = field.option['correctanswers'];// set default correct answers (response option id) here from portal api for multicheckbox only
          }

          templateOptions['displayCorrect'] = false;// as default hide custom style for this widget
          templateOptions['displayWrong'] = false;// as default hide custom style for this widget

        }

        // question response DisplayAs: single-one, single-one-optional
        // custom formly-field-select defined in node_modules\@ngx-formly\bootstrap\@ngx-formly\bootstrap.es5.js
        if (field.widget === 'select') {

          // pass correct answers value to the widget for checking later at component level
          if (_.has(field.option, 'correctanswers')) {
            templateOptions['correctanswers'] = field.option['correctanswers'];// set default correct answers (response option id) here from portal api for multicheckbox only
          }

          templateOptions['displayCorrect'] = false;// as default hide custom style for this widget
          templateOptions['displayWrong'] = false;// as default hide custom style for this widget

        }

        //console.log(templateOptions);

        return templateOptions;
    }

    private _isValidRegex(str: string): boolean {
        try {
            new RegExp(str);
            return true;
        } catch (err) {
            return false;
        }
    }

    private _getSubItems(oneOf: any[], type: string): any[] {
      const subItems = [];
        oneOf.map((item) => {
          subItems.push(this._createSubItem(type, item.description, item.enum[0]));
        });
        return subItems;

      /*else {
        oneOf.map((item) => {
          subItems.push(this._createSubItem('radio', item.description, item.enum[0]));//not sure why radio works
        });
        return subItems;
      }*/
    }

    private _createSubItem(type: string, text, value): Object {

        switch (type) {
            case 'radio':
                return {
                    key: value,
                    value: text
                };
            case 'select':
                return {
                    value: value,
                    label: text
                    };
            case 'multiselect':
                return {
                    value: value,
                    label: text
                    };
            case 'checkbox':
                return {
                    value: value,
                    label: text
                };
            case 'multicheckbox':
                return {
                    key: value,
                    value: text
                };

            default:
                return {};
        }
    }

    // end of private functions

    public  process(response: any): types.IProcessedData {

        const formlyData: types.IProcessedData = {
            config: [],
            model: {}
        };

        const questionWrapperTemplate = {
            className: 'wrapper-template-class',
            wrappers: ['questionWrapper'],
            templateOptions: {
                wrapperClasses: {
                    wrapperClass: ' wrapper-class',
                    wrapperLabel: ' wrapper-label-class',
                    wrapperContent: ' wrapper-content-class'
                },
                questionLabel: response['name']
            },
            fieldGroupClassName: 'row',
            fieldGroup: [] // will be pushed from  this.generateQuestionGroupTemplate()
        };

        // error catch here for erroneous page data
        try {

            const questionGroupTemplates: types.IQuestionGroupTemplate[] = this.generateQuestionGroupTemplate(response, formlyData.model);

            //Sconsole.log(questionGroupTemplates);

            questionWrapperTemplate.fieldGroup = questionGroupTemplates;

        } catch (error) {
            throw new Error(error);
            // const errorToLog: commonTypes.IError = {
            //     message: error.message,
            //     url: '',
            //     stack: this.loggy.getStackSync(3)
            // };

            // this.loggy.logError(errorToLog);
        }

        formlyData.config.push(questionWrapperTemplate);

        //console.log("formdata: ");
        //console.log(JSON.stringify(formlyData));
        return formlyData;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/generateFormlyData.ts